import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import goodsCard from '@/components/goodsCard/goodsCard.vue'
import serviceCard from '@/components/serviceCard/serviceCard.vue'
import addressListCard from '@/components/addressListCard/addressListCard'
import {
    getConfirmOrderDetail,
    postZeroPay
} from '@/models/confirmOrder'
import {
    getLocalConfig,
    setLocalConfig

} from '@/utils/session'
import {
    has,
    throttle
} from 'lodash'
import {
    Toast
} from 'vant'
import { getTencentAttribution } from '@/utils/tencentAttribution'
// import { log } from 'util'
export default {
    name: viewName.confirmOrder,
    components: {
        goodsCard,
        serviceCard,
        addressListCard
    },
    inject: ['showLoading', 'hideLoading'],
    data () {
        return {
            addressStatus: false,
            buttonStatus: {
                buttonLoading: false, // true 显示按钮加载状态， false 不显示按钮加载状态
                buttonDisabled: true // true 禁用按钮，false 可点击按钮
            },
            currentAddress: '',
            queryParams: {},
            order: {},
            delivery_id: '',
            message: [],
            serviceMessage: [], // 服务商品留言
            params: {}, // 请求的params
            selectCoupon: {},
            lock: false, // lock,0元支付，避免触发两次
        }
    },
    computed: {
        ...mapState({
            isKeepStatusForAddress: state => state.confirmOrder.isKeepStatusForAddress,
            orderInfo: state => state.confirmOrder.order,
            recipientType: state => state.confirmOrder.recipientType,
            messageArray: state => state.confirmOrder.messageArray, // 商品留言
            serviceMessageArray: state => state.confirmOrder.serviceMessageArray, // 服务留言
            /* 保养建议 选择的商品与服务 */
            adviceSelectData: ({ advice }) => advice.selectData,
        }),
        ...mapGetters(['user', 'addressInfo']),
        isNotData () {
            const {
                icar_name,
                icar_phone_number,
                icar_no
            } = this.order
            return !(icar_name + icar_phone_number + icar_no)
        },
        // 监听地址
        filterAddressList () {
            this.addressList.filter(item => item.is_default_address === '1')
        }
    },
    watch: {
        addressStatus (v) {
            if (v) {
                this.openAddressList()
            }
        },
        orderInfo (o) {
            if (has(o, 'order_id')) {
                if (Number(o.order_price) > 0) {
                    // 跳转到选择支付页面下一页
                    this.$router.push({
                        name: 'chooseToPay',
                        query: {
                            order_id: o.order_id,
                            order_type: 'sstore_goods',
                        }
                    })
                } else {
                    let params = {
                        order_id: o.order_id,
                        order_type: 'sstore_goods',
                    }
                    // v2.5 当订单金额=0时，调起0元支付、
                    if (!this.lock) {
                        this.lock = true
                        postZeroPay(params).then(() => {
                            this.$router.push({
                                name: 'payResult',
                                query: {
                                    order_id: o.order_id,
                                    order_type: 'sstore_goods',
                                }
                            })
                            this.lock = false
                        }).catch(() => {
                            this.lock = false
                        })
                    }
                }
            }
        },
        // 判断切换状态
        recipientType (n) {
            // console.error(n)
            console.log(n)
            // let {
            //     delivery_id
            // } = this
            // 判断是否到店提货
            if (n) {
                this.editParams('', 0)
            } else {
                if (this.addressInfo.delivery_id) {
                    this.editParams(this.addressInfo.delivery_id, 1)
                }
            }
        },
        params (n) {
            this.showLoading()
            this.apiConfirmOrderDetail(this.params)
        },
        addressInfo (newValue, oldValue) {
            if (newValue.delivery_id && newValue.delivery_id !== oldValue.delivery_id) {
                this.showLoading()
                if (!this.recipientType) {
                    this.editParams(this.addressInfo.delivery_id, 1)
                } else {
                    this.apiConfirmOrderDetail(this.params)
                }
            }
        }
    },
    async mounted () {
    },
    created () {
        // this.onChangeRecipientMember('store')
        this.selectCoupon = getLocalConfig('SELECT_COUPON')
        this.setBasic()
        this.queryParams = getLocalConfig('CONFIRM_ORDER')
        this.editParams('', 0)
        this.addressStatus = this.isKeepStatusForAddress
    },
    activated () {
        // this.openAddressList()
        this.setBasic()
        this.buttonStatus.buttonLoading = false
    },
    methods: {
        setBasic () {
            this.setAppClass({
                isAppend: true,
                className: 'bgGreyColor'
            })
            this.$emit('setHeader', {
                title: '确认订单',
                showHeader: true,
                showLeft: true
            })
        },
        errMethod (err) {
            if (err.errcode === 404) {
                this.$dialog.alert({
                    title: '提示',
                    message: err.errmsg
                }).then(() => {
                    this.$router.push({
                        path: '/pageNotFound',
                        query: {
                            sstore_id: this.queryParams.sstore_id,
                        }
                    })
                })
            } else if (err.errcode === 9006) {
                this.$dialog.alert({
                    message: '优惠券已失效'
                }).then(() => {
                    setLocalConfig('SELECT_COUPON', '')
                    let cacheParams = JSON.parse(JSON.stringify(this.params))
                    cacheParams.coupon_id = ''
                    cacheParams.type = ''
                    cacheParams.user_coupon_id = ''
                    this.params = cacheParams
                    this.selectCoupon = {}
                })
            } else if (err.errcode === 99) {
                this.$dialog.alert({
                    message: err.errmsg
                }).then(() => {
                    this.$router.go(-1)
                })
            } else if (err.errcode !== 106) {
                this.$router.go(-1)
            }
        },
        editParams (delivery_id, delivery_way) {
            let selectCoupon = this.selectCoupon
            const { maintain_id } = this.$route.query
            let {
                name,
                phone_number,
                letter_name_first,
                prov_name_first,
                car_no
            } = this.user
            let params = {
                delivery_id,
                delivery_way,
                sstore_id: this.queryParams.sstore_id,
                goods: JSON.stringify(this.queryParams.goods),
                services: this.queryParams.services ? JSON.stringify(this.queryParams.services) : JSON.stringify([]),
                maintain_id: maintain_id,
                sms_id: this.queryParams.sms_id || '',
                topic_id: this.queryParams.topic_id || '',
                user: !(
                    name +
                    phone_number +
                    prov_name_first +
                    letter_name_first +
                    car_no
                )
                    ? '' : JSON.stringify({
                        name: name,
                        phone_number: phone_number,
                        car_no: prov_name_first + letter_name_first + car_no
                    }),
                coupon_id: selectCoupon && selectCoupon.coupon_id ? selectCoupon.coupon_id : '',
                type: selectCoupon && selectCoupon.type ? selectCoupon.type : '',
                user_coupon_id: selectCoupon && selectCoupon.user_coupon_id ? selectCoupon.user_coupon_id : '',
            }
            this.params = params
        },
        ...mapActions([
            'editRecipientStatus',
            'setAppClass',
            'editLocationAddress',
            'postOrderInfo',
            'changeRecipientMember',
            'editMessageArray',
            'editServiceMessageArray',
            'clearAddressInfo'
        ]),
        /**
         * 运费提示
         */
        onFreightTips () {
            this.$dialog.alert({
                message: '当订单中包含厂商发货的商品时，您需支付厂家邮寄到门店的运费'
            })
        },
        // 修改收货人
        onChangeRecipientMember (type) {
            if (type === 'mail') {
                if (this.order.is_support_mailing === 0) {
                    Toast({
                        message: '当前商品暂不支持邮寄到家',
                        duration: 1500,
                        forbidClick: true,
                        closeOnClick: true
                    })
                } else {
                    this.changeRecipientMember(type)
                }
            } else {
                this.changeRecipientMember(type)
            }
        },
        openAddressList () {
            // 弹窗
            this.$refs.addressListCard.openModel()
        },
        // 提交订单
        commitOrder: throttle(function () {
            let selectCoupon = this.selectCoupon
            let {
                order,
                messageArray,
                serviceMessageArray,
                user
            } = this
            let {
                goods_package,
                service_package
            } = order

            let goods_array = []
            goods_package.forEach((ele, index) => {
                goods_array.push({
                    message: messageArray[index] || '',
                    freight_price: ele.freight,
                    freight_id: ele.freight_id,
                    goods: ele.goods,
                    warehouse_id: ele.warehouse_id
                })
            })
            /* 服务 */
            let service_array = []
            service_package.forEach((item, index) => {
                service_array.push({
                    message: serviceMessageArray[index] || '',
                    list: item.list.map((item2) => {
                        return {
                            service_id: item2.service_id,
                            price: item2.service_price,
                            quantity: item2.quantity,
                            baseItemCode: item2.baseItemCode
                        }
                    })
                })
            })

            // 判断参数是否完整
            if (!this.recipientType && !this.addressInfo.delivery_id) {
                // 打开设置
                return this.openAddressList()
            } else if (this.recipientType) {
                // 判断是否有用户数据
                if (!user['name']) {
                    // 提示
                    return this.$toast('请编辑提货人姓名')
                } else if (!user['phone_number']) {
                    return this.$toast('请编辑手机号码')
                } else if (!user['car_no']) {
                    return this.$toast('请编辑车牌号码')
                }
            }
            this.buttonStatus.buttonLoading = true
            const { maintain_id } = this.$route.query
            let pageCodeArr = [ // 活动商品下单统计逻辑不一样，需要带page_code和topic_id统计的页面,
                'mergeSpread', // 聚合推广
                'customDetail', // 商家自定义推广-多店
                // 'customSingularDetail', // 商家自定义推广-单店(暂不需要)
                'regularCustomDetail', // 商家常规推广-多店
                // 'marketingDetail', // 特价活动多店(暂不需要)
                // 'specialActivity', // 特价活动单店(暂不需要)
                // 'seckill', // 秒杀(暂时不需要)(暂不需要)
            ]
            let params = {
                // total_price: this.order.all_goods_total_payment_price, //  支付价
                delivery_id: this.addressInfo.delivery_id, // 收货地址id
                delivery_way: this.recipientType ? 0 : 1, // 配送方式， 0: 到店提货 1：邮寄到家
                sstore_id: this.queryParams.sstore_id, // 门店id
                goods_id: JSON.stringify(goods_array), // 订单商品信息（jsong格式）
                services: JSON.stringify(service_array), // 订单服务信息（jsong格式）
                marketing_id: this.queryParams.marketing_id, // 内容营销id
                maintain_id: maintain_id, // 保养方案id
                order_type: 'sstore_goods', //  sstore_goods: 商品订单类型
                sms_id: this.queryParams.sms_id || '', // 短信id
                topic_id: pageCodeArr.indexOf(this.queryParams.page_code) > -1 ? this.queryParams.topic_id : '', // 主题id/商家推广id
                page_code: pageCodeArr.indexOf(this.queryParams.page_code) > -1 ? this.queryParams.page_code : '',
                user: this.recipientType // 用户收货地址信息（json格式，到店提货必填）
                    ? JSON.stringify({
                        name: user.name, //  提货人
                        car_no: user.prov_name_first +
                            user.letter_name_first +
                            user.car_no, //  车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
                        phone_number: user.phone_number // 手机号,
                    }) : '',
                coupon_id: selectCoupon && selectCoupon.coupon_id ? selectCoupon.coupon_id : '',
                type: selectCoupon && selectCoupon.type ? selectCoupon.type : '',
                user_coupon_id: selectCoupon && selectCoupon.user_coupon_id ? selectCoupon.user_coupon_id : '', // 用户可用优惠券主键id
                page_from: this.queryParams.page_code || '', // 来源页面 区分商家推广id和主题id(mergeSpread 聚合推广,customSingularDetail 自定义推广详情,regularCustomDetail 商家常规推广)
                clickid: '', // 巨量/腾讯广告的点击id
                channel: '', // 广告渠道，1巨量，2腾讯
            }

            // 腾讯广告商品id一致性判断
            var attr = getTencentAttribution() || {}
            console.log(String(this.queryParams.goods[0].spu_id), String(attr.spu_id))
            if (
                this.queryParams.goods[0].spu_id &&
                attr.spu_id &&
                String(this.queryParams.goods[0].spu_id) === String(attr.spu_id)
            ) {
                params.clickid = attr.clickid
                params.channel = '2'
            }

            this.postOrderInfo(params)
                .then(res => {
                })
                .catch(err => {
                    // this.$router.go(-1)
                    this.errMethod(err)
                })
        }, 1000),
        setGoodsMessage (e, index) {
            let values = e.target.value
            this.message[index] = values
            this.editMessageArray(this.message)
        },
        setServiceMessage (e, index) {
            let values = e.target.value
            this.serviceMessage[index] = values
            this.editServiceMessageArray(this.serviceMessage)
        },
        navigationToEdit (type) {
            if (type) {
                const {
                    user
                } = this
                this.$router.push({
                    name: 'editOrderInfo',
                    query: {
                        icar_name: user.name,
                        icar_no: user.car_no,
                        icar_phone_number: user.phone_number
                    }
                })
            } else {
                this.openAddressList()
            }
        },
        async apiConfirmOrderDetail (params) {
            getConfirmOrderDetail(params)
                .then(back => {
                    // console.log(back.service_package.list)
                    this.buttonStatus.buttonLoading = false
                    this.order = {
                        ...back
                    }
                    let carNo = back.icar_no.slice(2)
                    let prov_name_first = back.icar_no[0]
                    let letter_name_first = back.icar_no[1]
                    this.editLocationAddress({
                        name: back.icar_name, // 提货人
                        car_no: carNo, // 车牌号，  提交订单时候，需要把车牌号提交到微养车，并生成一个默认爱车档案
                        phone_number: back.icar_phone_number, // 手机号,
                        prov_name: '',
                        letter_id: '',
                        prov_name_first: prov_name_first || '粤',
                        letter_name_first: letter_name_first || 'A'
                    })
                    this.hideLoading()
                })
                .catch(err => {
                    const { source } = this.$route.query
                    this.buttonStatus.buttonLoading = false
                    this.hideLoading()
                    if (err.errcode === 404) {
                        this.$dialog.alert({
                            title: '提示',
                            message: err.errmsg
                        }).then(() => {
                            // 如果是保养跳转到保养首页也就是上一页
                            if (source === 'advice') {
                                this.$router.go(-1)
                            } else {
                                this.$router.push({
                                    path: '/pageNotFound',
                                    query: {
                                        sstore_id: this.queryParams.sstore_id,
                                    }
                                })
                            }
                        })
                    } else {
                        // this.$router.go(-1)
                        this.errMethod(err)
                    }
                })
        },
        toUserCoupon (index) {
            let services = []
            this.order.service_package[index].list.forEach(item => {
                let attr = {
                    service_id: item.service_id,
                    num: item.quantity,
                }
                services.push(attr)
            })
            setLocalConfig('USE_COUPON_SERVICE', services)
            this.$router.push({
                name: 'userCoupon',
                query: {
                    sstore_id: this.queryParams.sstore_id,
                    coupon_id: ''
                }
            })
        },
    },

    destroyed () {
        this.onChangeRecipientMember('store')
        this.editRecipientStatus(false)
        // setLocalConfig('SELECT_COUPON', '')
    },
    // beforeRouteEnter (to, from, next) {
    //     to.meta.keepAlive = false // C 跳转到 A 时让 A 不缓存，即刷新
    //     next()
    // },
    beforeRouteLeave (to, from, next) {
        // 设置下一个路由的 meta
        const reg = /(editAddress)|(chooseToPay)|(editOrderInfo)/
        if (reg.test(to.name)) {
            from.meta.keepAlive = true // 不请求页面数据
        } else {
            this.clearAddressInfo()
            from.meta.keepAlive = false
        }
        if (to.name !== 'userCoupon' && to.name !== 'chooseToPay') {
            setLocalConfig('SELECT_COUPON', '')
        }
        next()
    }
}
